import PageContainer from "component/ui/PageContainer";
import PageHeading from "component/ui/PageHeading";
import React, { useEffect, useMemo, useState } from "react";
import profile from "../../assets/profile.png";
import Input from "component/ui/Input";
import {
  CARDS_ENUMS,
  ageGroup,
  gamesSportOptions,
  playerFilter,
  venueSearch,
} from "helper/constant";
import SelectField from "component/ui/SelectField";
import { FaUser } from "react-icons/fa";
import SearchInput from "component/ui/SearchInput";
import { FiSearch } from "react-icons/fi";
import MultiSelectWrapper from "component/ui/MultiSelectWrapper";
import Textarea from "component/ui/Textarea";
import Button from "component/ui/Button";
import RadioButton from "component/ui/RadioButton";
import DateAndTimePicker from "component/ui/Datepicker";
import { Trash } from "lucide-react";
import { useLoginData } from "component/common/loginData";
import { convertDateTimeUtc, createUniqueId, getCountryCode, getCurrentcoords } from "helper/appConstant";
import { getListOfVenueSlots, getVenueSelectedSportsList } from "store/slice/profile";
import { useDispatch, useSelector } from "react-redux";
import { createGameOn, createVenue, fetchPlayerList, fetchVenues, getPaymentCardsList, onBookVenue } from "store/slice/booking";
import { toast } from "react-toastify";
import FullPageLoader from "component/ui/fullPageLoader";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import PaymentSummary from "./paymentSummary";
import CheckoutForm from "./paymentSummary/CheckoutForm";
import SelectCard from "./paymentSummary/selectCard";

const ClubVenue = () => {
  const userData = useLoginData();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState();
  const [selectedPlayer, setSelectedPlayer] = useState(false);
  const [listType, setListType] = useState();
  const [refValue, setRefValue] = useState("");
  const [formData, setFormData] = useState({ venueName: userData?.name });
  const { venueSelectedSportsData, userProfileData } = useSelector((state) => state.profile);
  const [coords, setCoords] = useState(null);
  const [loader, setLoader] = useState(false);
  const [cardLoader, setCardLoader] = useState(false);
  const [bookingStatus, setBookingStatus] = useState(0);
  const [paymentData, setPaymentData] = useState(null);
  const { venuesList, playerList, paymentCardsData } = useSelector((state) => state.booking);
  const { venueBookingSlotsList, venueBookedSlots } = useSelector(
    (state) => state.profile
  );
  const [slotsData, setSlotsData] = useState(null);
  const listMap = {
    venuesList,
    playerList,
  };


  useEffect(() => {
    if (venueSelectedSportsData?.length == 0) {
      dispatch(getVenueSelectedSportsList());
    }
    fetchCoords();
  }, []);

  useEffect(() => {
    if (coords && userProfileData?.data) {
      getVenues();
      getAllPlayerList();
    }
  }, [coords, formData?.category, formData?.bookingDate, userProfileData?.data, searchQuery]);

  useEffect(() => {
    if (formData?.venueId) {
      getSlots();
    }
  }, [formData?.venueId]);

  // set slots data
  useEffect(() => {
    if (venueBookingSlotsList) {
      setSlotsData(venueBookingSlotsList?.data);
    }
  }, [venueBookingSlotsList]);

  const [playerCount, setPlayerCount] = useState(0);
  const [players, setPlayers] = useState([]);

  const handleCountChange = (value) => {
    const number = Math.max(0, Number(value));
    setPlayerCount(number);

    setPlayers((prev) => {
      if (number - 1 > prev.length) {
        return [...prev, ...Array(number - 1 - prev.length).fill("")];
      }
      return prev.slice(0, number - 1);
    });
  };

  const removePlayer = (index) => {
    const updated = players.filter((_, i) => i !== index);
    setPlayers(updated);
    setPlayerCount(updated.length);
  };

  const handleChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const fetchCoords = async () => {
    try {
      const locationData = await getCurrentcoords();
      setCoords(locationData);
    } catch (error) {
      console.error("Error fetching coordinates:", error);
    }
  };

  const getVenues = () => {
    const data = {
      language: "en",
      page: 1,
      perPage: 50,
      searchQuery: "",
      sportName: formData?.category,
      latitude: userProfileData?.data?.location?.coordinates[1],
      longitude: userProfileData?.data?.location?.coordinates[0],
      bookingDate: formData?.bookingDate
    };
    dispatch(fetchVenues(data));
  }

  const getAllPlayerList = () => {
    const data = {
      "language": "en",
      "page": 1,
      "perPage": 50,
      "search": "",
      "latitude": userProfileData?.data?.location?.coordinates[1],
      "longitude": userProfileData?.data?.location?.coordinates[0]
    };
    dispatch(fetchPlayerList(data));
  }

  const getSlots = () => {
    const data = {
      language: "en",
      sportsName: formData?.category,
      venueId: formData?.venueId,
      country: "AU",
      courtDetailId: null,
      slotStartTime: "",
      slotDate: moment(formData?.bookingDate)?.format("YYYY-MM-DD")
    };
    dispatch(getListOfVenueSlots(data));
  }

  const validateEventFields = () => {
    const requiredFields = [
      { key: "cardReferenceID", label: "card Reference ID" },
      { key: "category", label: "Game / Sport" },
      { key: "ageGroup", label: "Age group" },
      { key: "bookingDate", label: "Booking date" },
      // { key: "venueName", label: "Venue" },
    ];

    for (let field of requiredFields) {
      const value = formData?.[field.key];
      // empty / blank check
      if (
        value === undefined ||
        value === null ||
        (typeof value === "string" && !value.trim())
      ) {
        toast.error(`${field.label} is required`);
        return false;
      }
    }

    return true;
  };
  // Example submit
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateEventFields()) return;
    setBookingStatus(1)
  };

  const toggleSlot = (slotId, sportId) => {
    setSlotsData((prev) =>
      prev.map((court) => ({
        ...court,
        sportsId: sportId,
        slots: court.slots.map((slot) =>
          slot.slotId === slotId
            ? { ...slot, isSelected: !slot.isSelected }
            : slot
        ),
      }))
    );
  };

  const selectedSlots = useMemo(
    () =>
      slotsData
        ?.flatMap(c => c.slots || [])
        .filter(s => s.isSelected)
        .map(s => ({
          slotId: s.slotId,
          courtName: s.courtName,
          courtDetailId: s.courtDetailId,
          ...s.paymentBreakdown
        })) || [],
    [slotsData]
  );

  const selectedSlotIds = useMemo(
    () => selectedSlots.map(s => s.slotId),
    [selectedSlots]
  );


  const fetchCardsList = async () => {
    dispatch(getPaymentCardsList(await getCountryCode(userData), setBookingStatus, setCardLoader));
  };

  const handlePayment = (selectedCard) => {
    const data = {
      language: "en",
      purchaseType: 2,
      startDateTimeUtc: null,
      productId: "",
      paymentToken: selectedCard?.id,
      paymentResponse: null,
      country: "AU",
      currency: "AUD",
      totalAmount: paymentData?.total,
      fees: paymentData?.gst,//gst total
      paidBy: selectedCard?.cardType,
      cardBrand: selectedCard?.cardBrand,
      description: formData?.description,
      sportsId: slotsData[0]?.sportsId,
      slotsIds: selectedSlotIds,
      bookingDate: formData?.bookingDate,
      buyerName: "",
      address: {
        "line1": formData?.address,
        "postal_code": "",
        "city": "",
        "state": "",
        "country": ""
      },
      venueId: formData?.venueId,
      cardReferenceID: formData?.cardReferenceID,
      slotPayment: selectedSlots
    }
    setCardLoader(true);
    dispatch(onBookVenue(data, onCreateVenue));
  };

  const onCreateVenue = (paymentResult) => {
    const data = {
      "language": "en",
      "cardReferenceID": formData?.cardReferenceID,
      "venueId": formData?.venueId,
      "category": formData?.category,
      "startDate": formData?.bookingDate,
      "startTime": "00:00",
      "noOfHoursVanueRequired": 0,
      "noOfPlayreAttanding": formData?.noOfPlayreAttanding,
      "requireKit": formData?.isBringYourOwnGameSportKit,
      "crewAvailabDateTime": null,
      "crewAssociated": false,
      "crewReferenceID": null,
      "address": formData?.address,
      "isBringYourOwnGameSportKit": formData?.isBringYourOwnGameSportKit,
      "coordinates": formData?.coordinates,
      "otherRequirements": formData?.otherRequirements,
      "description": formData?.description,
      "ageGroup": formData?.ageGroup,
      "budget": 0,
      "startDateTimeUtc": null,
      "venueName": formData?.venue,
      "cardId": null,
      "paymentId": paymentResult?.paymentId,
      "anySpecificVenueInterest": formData?.venueId,
      "selectedUserIds": formData?.selectedUserIds
    }
    dispatch(createVenue(data, setBookingStatus, navigate, setCardLoader));
  }

  return (
    <PageContainer>
      {loader && <FullPageLoader />}
      <div className="lg:max-w-5xl w-full mx-auto">
        <PageHeading title={"Book a venue"} Subtitle={"Find & Book a Venue"} />
      </div>
      <div className="lg:max-w-5xl w-full mx-auto lg:p-6 p-3 rounded-lg bg-white">
        <div className="flex items-center gap-3 mb-8">
          <img
            src={profile}
            alt="Profile image"
            className="w-12 h-12 rounded-full bg-gray-200 text-white flex items-center justify-center font-bold text-xl border  object-contain"
          />
          <p>Test</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-2">
          <RadioButton
            label="Do you have a reference id"
            isRequired={true}
            selected={formData?.cardReferenceType}
            options={["Yes", "No"]}
            onChange={(e) => {
              console.log('e == ', e.target.value);
              if (e.target.value == "yes") {
                handleChange(
                  "cardReferenceID", ""
                );
              } else {
                handleChange("cardReferenceID",
                  createUniqueId(CARDS_ENUMS?.VENUE));
              }
              handleChange("cardReferenceType", e.target.value);
            }}
          />

          <RadioButton
            label="Kit required"
            options={["Yes", "No"]}
            selected={formData?.isBringYourOwnGameSportKit}
            onChange={(e) => handleChange("isBringYourOwnGameSportKit", e.target.value)}
            isRequired={true}
          />
          <Input
            label="Reference id"
            placeholder="Enter reference id"
            required
            value={formData?.cardReferenceID}
            onChange={(e) => setRefValue(e.target.value)}
            className="w-full"
          />

          <SelectField
            label="Select game or sport"
            value={formData?.category}
            onChange={(value) => handleChange("category", value)}
            isSport={true}
            options={venueSelectedSportsData}
            isRequired={true}
            placeholder="Select game or sport"
          />

          <SelectField
            id="age-select"
            label="Age group playing"
            isRequired
            placeholder="Age group playing"
            name="age"
            options={ageGroup}
            value={formData?.ageGroup}
            onChange={(value) => handleChange("ageGroup", value)}
          />

          <DateAndTimePicker
            showDate
            dateLabel="Select Date"
            showTime={false}
            placeholderDate="Select Date"
            isRequired
            inputClassName="w-full"
            selectedDate={formData?.bookingDate}
            onDateChange={(date) => handleChange("bookingDate", date ? moment(date).format("YYYY-MM-DD") : "")}
          />

          <div className="space-y-4">
            {/* Number input */}
            <Input
              type="number"
              min={0}
              label="Total number of players (including yourself)"
              placeholder="Enter number of players"
              required
              className="w-full"
              value={formData?.noOfPlayreAttanding}
              onChange={(value) => {
                handleChange(
                  "noOfPlayreAttanding", value
                );
                handleCountChange(value)
              }}
            />
            {/* Dynamic player inputs */}
            {players.map((player, index) => (
              <div
                key={index}
                className="flex items-center justify-between md:gap-2 gap-1"
              >
                <Input
                  placeholder={`Enter player name ${index + 1}`}
                  className="md:w-full w-[90%]"
                  value={formData?.selectedUserIds && formData?.selectedUserIds[index]?.name}
                  onFocus={() => { setSelectedPlayer(true); setListType({ type: 'playerList', index: index }) }}
                />

                <button
                  type="button"
                  onClick={() => removePlayer(index)}
                  className="text-red-500"
                  aria-label="Delete player"
                >
                  {/* 🗑️ */}
                  <Trash size={18} />
                </button>
              </div>
            ))}
          </div>


          <SearchInput
            label="Venue name"
            value={formData?.venue}
            onFocus={() => { setSelectedPlayer(true); setListType({ type: 'venuesList', index: -1 }) }}
            placeholder="Input username or @username"
            iconClass="top-[65%]"
            inputClass="!pl-4"
            isRequired
            onChange={(value) => {
              handleChange(
                "venueId", value
              );
            }}
          />
        </div>

        {/*  slots */}
        <div className="space-y-4 mb-2">
          {slotsData?.map((slot) => {
            return (
              <div key={slot?.id} className="border rounded-md shadow-sm">
                <div className="flex justify-between items-center p-4 bg-gray-100 hover:bg-gray-100">
                  <div className="flex w-full justify-between">
                    <p className="text-sky-500 font-semibold text-lg">
                      {slot?.courtName}
                    </p>
                    <p className="text-sm text-gray-500">
                      Available spaces:{" "}
                      <span className=" text-lg font-semibold text-highlight">
                        {" "}
                        {slot?.availableSpace}
                      </span>
                    </p>
                  </div>
                </div>
                {!slot?.courdBooked && (
                  <div className="p-4">
                    {slot?.slots?.length > 0 ? (
                      <>
                        <div className="grid  grid-cols-8 gap-4 mb-6">
                          {slot?.slots.map((time) => {
                            return (
                              <button
                                key={time?.slotId}
                                onClick={() =>
                                  toggleSlot(time?.slotId, time?.sportId)
                                }
                                disabled={!time?.slotAvailable}
                                className={`py-3 rounded-lg text-sm font-medium
                    ${!time?.slotAvailable
                                    ? "bg-gray-300 text-black cursor-not-allowed"
                                    : time?.isSelected
                                      ? "bg-green-500 text-white"
                                      : "bg-sky-500 hover:bg-sky-600 text-white"
                                  }`}
                              >
                                {`${time?.fromTime}-${time?.toTime}`}
                              </button>
                            );
                          })}
                        </div>
                      </>
                    ) : (
                      <div className="text-lg text-center">
                        No slots are available to block
                      </div>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
        <>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 my-3">
            <Textarea
              id="message"
              label="Description"
              value={formData?.description}
              onChange={(e) => handleChange("description", e.target.value)}
              placeholder="Enter Description"
              rows={6}
            />

            <Textarea
              id="message"
              label="Other Requirements"
              value={formData?.otherRequirements}
              onChange={(e) => handleChange("otherRequirements", e.target.value)}
              placeholder="Other Requirements"
              rows={6}
            />
          </div>
        </>

        <div className="flex justify-center mt-3">
          <Button onClick={handleSubmit}>Request/Book Venue</Button>
        </div>
      </div>

      {selectedPlayer && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm px-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden animate-fadeIn">
            {/* Header */}
            <div className="bg-gradient-to-r from-[#2BACE2] to-[#1a8ec4] px-6 py-4 flex items-center justify-between">
              <h3 className="text-lg font-semibold text-white">{listType?.type == 'playerList' ? 'Player' : 'Venue'} name</h3>
              <button
                onClick={() => setSelectedPlayer(null)}
                className="text-white text-xl hover:opacity-80"
              >
                ✕
              </button>
            </div>

            {/* Content */}
            <div className="p-4">
              <SearchInput
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Search venue name or @username"
                icon={FiSearch}
              />

              <div className="overflow-y-auto md:h-96 h-72 thin-scrollbar">
                {listMap[listType?.type].map((item, index) => (
                  <div className="flex items-center justify-between my-3 pr-4"
                    onClick={() => {
                      if (listType?.type == 'playerList') {
                        let data = formData?.selectedUserIds ? [...formData?.selectedUserIds] : [];
                        data[listType.index] = {
                          name: item?.name,
                          id: item.id
                        }
                        handleChange("selectedUserIds", data);
                      } else {
                        handleChange("venue", item?.name);
                        handleChange("venueId", item?.id);
                        handleChange("address", item?.address);
                        handleChange("coordinates", item?.coordinates);
                      }
                      setSelectedPlayer(false);
                    }}>
                    <div className="flex items-center md:gap-5 gap-3">
                      <img
                        src={item.imageUrl}
                        alt={item.name}
                        className="md:w-10 md:h-10 w-7 h-7 rounded-full"
                      />
                      <p className="md:text-base text-sm">{item.name}</p>
                    </div>
                    <FaUser fill="#2bace2" />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {bookingStatus ? (
        <div
          className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[100]"
        // onClick={() => setShareOpen(false)}
        >
          {bookingStatus == 1 ?
            <PaymentSummary
              slots={selectedSlots}
              selectedSlots={selectedSlotIds}
              handleNext={() => { fetchCardsList(); setCardLoader(true) }}
              onClose={() => setBookingStatus(0)}
              setPaymentData={setPaymentData}
              cardLoader={cardLoader}
            /> :
            bookingStatus == 2 ?
              <SelectCard
                paymentCardsData={paymentCardsData}
                setBookingStatus={setBookingStatus}
                handlePayment={handlePayment}
                cardLoader={cardLoader} /> :
              <CheckoutForm handleNext={() => setBookingStatus(2)}
                onClose={() => setBookingStatus(0)} setBookingStatus={setBookingStatus}
                userProfileData={userProfileData?.data} fetchCardsList={fetchCardsList} />}
        </div>
      ) : ''}
    </PageContainer>
  );
};

export default ClubVenue;
